import { combineReducers, configureStore } from '@reduxjs/toolkit'
import showAuthorIdReducer from './features/SetShowAuthorId/setShowAuthorId'
import loginReducer from './features/Login/login'
import showWorkIdReducer from './features/SetShowWorkId/setShowWorkId'
import setAnalysisImageInfoReducer from './features/SetAnalysisImageInfo/setAnalysisImageInfo'
import setOverviewTagsListReducer from './features/SetOverviewTagsList/setOverviewTagsList'
import setOverviewTypeListReducer from './features/SetOverviewTypeList/setOverviewTypeList'
import setCompareTagsListReducer from './features/SetCompareTagsList/setCompareTagsList'
import setCompareTypeListReducer from './features/SetCompareTypeList/setCompareTypeList'
import setLikesPageListReducer from './features/SetLikesPageList/setLikesPageList'
import setSelectedRectsReducer from './features/SetSelectedRects/setSelectedRects'
import setIndexSecondInfoReducer from './features/SetIndexSecondInfo/setIndexSecondInfo'
import setSearchKeyReducer from './features/SetSearchKey'
import setSixLawsInfoReducer from './features/SetSixLawsInfo/setSixLawsInfo'
import setCompareInfoReducer from './features/SetCompareInfo/setCompareInfo'
import setPaintingIntroInfo from './features/SetPaintingIntroInfo/setPaintingIntroInfo'
import wordAnimationReducer from './features/SetWordAnimationObj/setWordAnimationObj'
import setPoemReducer from './features/SetPoemInfo/setPoemInfo'
import setCompareImageInfoReducer from './features/SetCompareImageInfo/setCompareImageInfo'
import setBackgroundColorReducer from './features/SetBackgroundColor/setBackgroundColor'

import { persistReducer } from 'redux-persist'
import thunk from 'redux-thunk'
import localforage from 'localforage'

const reducers = combineReducers({
  login: loginReducer,
  authorId: showAuthorIdReducer,
  showWorkId: showWorkIdReducer,
  analysisImageInfo: setAnalysisImageInfoReducer,
  overviewTagsList: setOverviewTagsListReducer,
  overviewTypeList: setOverviewTypeListReducer,
  compareTagsList: setCompareTagsListReducer,
  compareTypeList: setCompareTypeListReducer,
  selectedRects: setSelectedRectsReducer,
  indexSecondInfo: setIndexSecondInfoReducer,
  searchKey: setSearchKeyReducer,
  sixLawsInfo: setSixLawsInfoReducer,
  compareInfo: setCompareInfoReducer,
  paintingIntroInfo: setPaintingIntroInfo,
  wordAnimation: wordAnimationReducer,
  poemInfo: setPoemReducer,
  likesPageList: setLikesPageListReducer,
  compareImageInfo: setCompareImageInfoReducer,
  backgroundColor: setBackgroundColorReducer
})

const persistConfig = {
  key: 'root',
  storage: localforage,
  blacklist: [
    'overviewTagsList',
    'overviewTypeList',
    'compareTagsList',
    'compareTypeList',
    'selectedRects',
    'sixLawsInfo',
    'compareInfo',
    'paintingIntroInfo'
  ]
}
const persistedReducer = persistReducer(persistConfig, reducers)

const store = configureStore({
  reducer: persistedReducer,
  devTools: !import.meta.env.PROD,
  middleware: [thunk]
})

// 从 store 本身推断 `RootState` 和 `AppDispatch` 类型
export type RootState = ReturnType<typeof store.getState>
// 推断类型：{posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
export default store
